module.exports = __webpack_public_path__ + "img/login-art-alt.f3d5ba4b.svg";